import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { RL1ReportPageSetup } from "../../../components/Reports/RL1Report";

export interface IRL1ReportPage {}

export const RL1ReportPage: FC<IRL1ReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="RL1 Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<RL1ReportPageSetup />}
		/>
	);
};
